export const BASE_URL = 'https://transist-alert-hub-server.onrender.com'